import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useState } from 'react';
export var useTabs = function useTabs(tabs, onTabChange) {
  var _tabs$;
  var _useState = useState((_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.id),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    index = _useState4[0],
    setIndex = _useState4[1];
  var onChange = useCallback(function (id) {
    var _tabs$newIndex;
    setSelectedTab(id);
    var newIndex = tabs.findIndex(function (tab) {
      return tab.id === id;
    });
    if (newIndex === -1) {
      return;
    }
    setIndex(newIndex);
    onTabChange === null || onTabChange === void 0 ? void 0 : onTabChange((_tabs$newIndex = tabs[newIndex]) === null || _tabs$newIndex === void 0 ? void 0 : _tabs$newIndex.title);
  }, [tabs, onTabChange]);
  return {
    index: index,
    selectedTab: selectedTab,
    onChange: onChange
  };
};